import { ConditionGroup, GatewayRule } from 'types/embedded/gatewayRule';

type ConditionCodes = {
  currencyCodes: string[];
  countryCodes: string[];
};

function collectFromGroup(
  group: ConditionGroup | undefined,
  currencyCodes: Set<string>,
  countryCodes: Set<string>,
): void {
  if (!group) {
    return;
  }

  group.expressions?.forEach((expression) => {
    const alias = expression.expressionParam?.alias;
    const value = expression.value;

    if (!Array.isArray(value)) {
      return;
    }

    if (alias === 'currency') {
      value.forEach((code) => typeof code === 'string' && currencyCodes.add(code));
    } else if (alias === 'country') {
      value.forEach((code) => typeof code === 'string' && countryCodes.add(code));
    }
  });

  group.children?.forEach((child) => collectFromGroup(child, currencyCodes, countryCodes));
}

export function extractConditionCodes(rule?: GatewayRule): ConditionCodes {
  const currencyCodes = new Set<string>();
  const countryCodes = new Set<string>();

  collectFromGroup(rule?.conditionGroup, currencyCodes, countryCodes);

  return {
    currencyCodes: Array.from(currencyCodes),
    countryCodes: Array.from(countryCodes),
  };
}
